import { format, parseISO } from 'date-fns';

import { TripDriverCache } from '@lib/types';

export function getRemainingTimeFromEstimatedMovingDuration(
  tripData: TripDriverCache,
): number {
  if (tripData) {
    const acceptedTime = Number(format(parseISO(tripData.acceptedTime), 'T')); // return accepted time in milliseconds

    const estimatedDeliveryTime =
      acceptedTime + tripData.estimatedMovingDuration * 1000; // tripData.estimatedMovingDuration is seconds

    const currentTime = new Date().getTime(); // return current time in milliseconds
    if (currentTime < estimatedDeliveryTime) {
      const remainingTime = (estimatedDeliveryTime - currentTime) / 1000; // convert result to seconds
      return remainingTime;
    }
    return 0;
  }
  return 0;
}
